import * as Slot from '@radix-ui/react-slot';
import type { HTMLProps, ReactNode } from 'react';

import { cn } from '~/lib/cn';
import { variants } from '~/lib/variants';

import type { ComponentProps } from '../ComponentProps';
import { getClassNameOverride } from '../getClassNameOverride';

export interface LabelProps
  extends ComponentProps<HTMLProps<HTMLLabelElement>> {
  asChild?: boolean;
  children: ReactNode;
  disabled?: boolean;
  required?: boolean;
  /**
   * @deprecated Use `asChild` instead
   */
  asSpan?: boolean;
}

const label = variants({
  base: ['text-body-sm', 'text-default'],
  variants: {
    disabled: {
      true: ['text-disabled'],
    },
    required: {
      true: ['after:ml-xs after:content-["*"]'],
    },
  },
});

function Label({
  asChild,
  children,
  disabled = false,
  required = false,
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  asSpan,
  ...props
}: LabelProps) {
  let Component = asChild ? Slot.Slot : 'label';

  if (asSpan) {
    Component = 'span';
  }

  const className = getClassNameOverride(props);

  return (
    <Component
      {...props}
      className={cn(label({ disabled, required }), className)}
    >
      {children}
    </Component>
  );
}

Label.displayName = 'Label';

export { Label };
